import Iconify from 'src/components/Iconify';
import { MKT } from '../marketing.design';

// Icon box + titulo + subtitulo + voltar opcional + slots de acoes/badges.
// Existia em 5 dialetos diferentes (w-12/w-11/p-2, bg-violet-100/50,
// rounded-lg/xl/2xl) espalhados pelas paginas de Marketing — este componente
// e o unico lugar que decide essa forma agora.
// iconVariant='brand' para logos de terceiros (logos:facebook, logos:messenger,
// logos:whatsapp-icon): sao SVGs multicoloridos, entao o box violeta + a classe
// de tint do padrao nao servem — o icone sai na cor da marca, sobre neutro.
export default function MktPageHeader({ icon, iconVariant = 'accent', title, subtitle, onBack, actions, badges, meta }) {
    const isBrand = iconVariant === 'brand';
    return (
        <div className={MKT.header.wrapper}>
            <div className={MKT.header.left}>
                {onBack && (
                    <button type="button" onClick={onBack} className={MKT.header.backBtn}>
                        <Iconify icon="eva:arrow-back-outline" width={18} />
                    </button>
                )}
                <div className="min-w-0">
                    <h1 className={MKT.header.title}>{title}</h1>
                    {subtitle && <p className={MKT.header.subtitle}>{subtitle}</p>}
                    {badges && <div className={`${MKT.header.badgeRow} mt-1.5`}>{badges}</div>}
                </div>
            </div>
            {actions && <div className={MKT.header.actions}>{actions}</div>}

            {meta && <div className={`${MKT.header.metaRow} basis-full`}>{meta}</div>}
        </div>
    );
}
